import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {
    Box,
    RangeSlider,
    RangeSliderTrack,
    RangeSliderFilledTrack,
    RangeSliderMark,
    RangeSliderThumb
} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {FormattedNumber} from 'react-intl'
import {useCurrency} from '../../../hooks'
import {parsePriceValue} from '../utils/parse-price-value'
import useEffectEvent from '../../../hooks/use-effect-event'

const PriceRefinements = ({filter, toggleFilter, selectedFilters}) => {
    const min = useMemo(() => parsePriceValue(filter.values[0].value)[0], [filter])
    const max = useMemo(
        () => parsePriceValue(filter.values[filter.values.length - 1].value)[1],
        [filter]
    )
    const {currency} = useCurrency()

    const parseSelected = useCallback(
        (selectedFilters) => {
            const selectedValue = Array.isArray(selectedFilters)
                ? selectedFilters[0]
                : selectedFilters
            return selectedValue ? parsePriceValue(selectedValue) : [min, max]
        },
        [min, max]
    )

    // needed to avoid the slider being stuck on the initial value
    const [selected, setSelected] = useState(parseSelected(selectedFilters))

    const onFiltersCleared = useEffectEvent(() => setSelected([min, max]))
    useEffect(() => {
        // reset the slider when reset-all selected
        if (!selectedFilters) {
            onFiltersCleared()
        }
    }, [onFiltersCleared, selectedFilters])

    const onChange = useCallback(
        (values) => {
            setSelected(values)
        },
        [setSelected]
    )

    const onChangeEnd = useCallback(
        (values) => {
            toggleFilter({value: `(${values[0]}..${values[1]})`}, filter.attributeId, false, false)
        },
        [toggleFilter, filter]
    )

    return (
        <Box mr={6} maxW="100%">
            <RangeSlider
                defaultValue={[min, max]}
                value={selected}
                min={min}
                max={max}
                mb={10}
                onChangeEnd={onChangeEnd}
                onChange={onChange}
            >
                <RangeSliderTrack bg="stokkeGray.mid">
                    <RangeSliderFilledTrack bg="stokkeCore.orange" />
                </RangeSliderTrack>

                <RangeSliderMark value={min} mt={6}>
                    <FormattedNumber style="currency" currency={currency} value={selected[0]} />
                </RangeSliderMark>
                <RangeSliderMark value={selected[0]} mt={6} right={-6} left={`unset !important`}>
                    <FormattedNumber style="currency" currency={currency} value={selected[1]} />
                </RangeSliderMark>

                <RangeSliderThumb boxSize={6} index={0} bg="stokkeCore.orange" />
                <RangeSliderThumb boxSize={6} index={1} bg="stokkeCore.orange" />
            </RangeSlider>
        </Box>
    )
}

PriceRefinements.propTypes = {
    filter: PropTypes.object,
    toggleFilter: PropTypes.func,
    selectedFilters: PropTypes.array
}

export default PriceRefinements
